import {Select} from 'antd';

import {selectRatingContentStars} from '../../../../layout/select/select-helper';
import {Locale} from '../../../../provider/locale/locale';
import {ReviewsTonalityFilterEnum} from '../../reviews/review-list-page-content/reviews-filter/reviews-filter-type';

const {Option} = Select;

// Reuse the reviews list option groups so the controls stay in sync (BST-10425).
export {
    CONTENT_OF_REVIEWS_OPTIONS,
    POSSIBILITY_OF_AN_ANSWER_OPTIONS,
    REPLIES_TO_REVIEWS_OPTIONS,
    REVIEW_TYPE_OPTIONS,
} from '../../reviews/review-list-page-content/reviews-filter/reviews-filter-const';

type OptionType<ValueType extends string> = {
    label: JSX.Element;
    value: ValueType;
};

// Ratings 1–5 as star lines + "Без оценки" (0), using the reviews section wording.
export const RATING_SELECT_CONTENT: Array<JSX.Element> = [
    ...selectRatingContentStars,
    <Option key="no-rating" value={0}>
        <Locale stringKey="REVIEWS__RADIO__NOT_RATED" />
    </Option>,
];

export const SENTIMENT_OPTIONS: Array<OptionType<ReviewsTonalityFilterEnum>> = [
    {label: <Locale stringKey="REVIEWS__FILTER__TONALITY__POSITIVE" />, value: ReviewsTonalityFilterEnum.positive},
    {label: <Locale stringKey="REVIEWS__FILTER__TONALITY__NEUTRAL" />, value: ReviewsTonalityFilterEnum.neutral},
    {label: <Locale stringKey="REVIEWS__FILTER__TONALITY__NEGATIVE" />, value: ReviewsTonalityFilterEnum.negative},
];

// `include deleted` is a plain boolean (default Yes), rendered as a non-clearable Yes/No segment.
export const INCLUDE_DELETED_OPTIONS: Array<{label: JSX.Element; value: boolean}> = [
    {label: <Locale stringKey="TEXT__YES" />, value: true},
    {label: <Locale stringKey="TEXT__NO" />, value: false},
];
